module.exports = __webpack_public_path__ + "static/img/10021C_1_R_20210905_LC.c8b974e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/10021C_1_R_20210905_LC.png
// module id = r0wi
// module chunks = 0